module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.sourceOnly) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('eligibility')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("NRHP Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.evaluation.eligibilityId),
      expression: "evaluation.eligibilityId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "eligibility"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.evaluation, "eligibilityId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.eligibilityTypeList), function(eligibilityType) {
    return _c('option', {
      key: eligibilityType.eligibilityId,
      domProps: {
        "value": eligibilityType.eligibilityId
      }
    }, [_vm._v("\n                    " + _vm._s(eligibilityType.description) + "\n                ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('eligibility')),
      expression: "errors.has('eligibility')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Eligibility is required")])]), _vm._v(" "), (_vm.isEligible) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.evaluation.isKeeperDetermined),
      expression: "evaluation.isKeeperDetermined"
    }],
    attrs: {
      "type": "checkbox",
      "id": 'isKeeper',
      "value": "keeper"
    },
    domProps: {
      "checked": Array.isArray(_vm.evaluation.isKeeperDetermined) ? _vm._i(_vm.evaluation.isKeeperDetermined, "keeper") > -1 : (_vm.evaluation.isKeeperDetermined)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.evaluation.isKeeperDetermined,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "keeper",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.evaluation.isKeeperDetermined = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.evaluation.isKeeperDetermined = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.evaluation, "isKeeperDetermined", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'isKeeper'
    }
  }, [_vm._v("Eligible by NRHP Keeper")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.sourceOnly) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-8",
    attrs: {
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.culturalResource.isListed),
      expression: "culturalResource.isListed"
    }],
    attrs: {
      "type": "checkbox",
      "id": "isListed"
    },
    domProps: {
      "checked": Array.isArray(_vm.culturalResource.isListed) ? _vm._i(_vm.culturalResource.isListed, null) > -1 : (_vm.culturalResource.isListed)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.culturalResource.isListed,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.culturalResource.isListed = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.culturalResource.isListed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.culturalResource, "isListed", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isListed"
    }
  }, [_vm._v("Listed")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.culturalResource.isLandmark),
      expression: "culturalResource.isLandmark"
    }],
    attrs: {
      "type": "checkbox",
      "id": "isLandmark"
    },
    domProps: {
      "checked": Array.isArray(_vm.culturalResource.isLandmark) ? _vm._i(_vm.culturalResource.isLandmark, null) > -1 : (_vm.culturalResource.isLandmark)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.culturalResource.isLandmark,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.culturalResource.isLandmark = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.culturalResource.isLandmark = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.culturalResource, "isLandmark", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isLandmark"
    }
  }, [_vm._v("Landmark")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.culturalResource.isMonument),
      expression: "culturalResource.isMonument"
    }],
    attrs: {
      "type": "checkbox",
      "id": "isMonument"
    },
    domProps: {
      "checked": Array.isArray(_vm.culturalResource.isMonument) ? _vm._i(_vm.culturalResource.isMonument, null) > -1 : (_vm.culturalResource.isMonument)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.culturalResource.isMonument,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.culturalResource.isMonument = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.culturalResource.isMonument = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.culturalResource, "isMonument", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isMonument"
    }
  }, [_vm._v("Monument")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Source")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.evaluation.concurredId),
      expression: "evaluation.concurredId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "concurred"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.evaluation, "concurredId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.concurredList), function(concurredType) {
    return _c('option', {
      key: concurredType.concurredId,
      domProps: {
        "value": concurredType.concurredId
      }
    }, [_vm._v("\n                    " + _vm._s(concurredType.description) + "\n                ")])
  })], 2)])]), _vm._v(" "), (_vm.isEligible && !_vm.sourceOnly) ? _c('div', [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('criteria_group')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Criteria Met")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    attrs: {
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.evaluation.isEligibleA),
      expression: "evaluation.isEligibleA"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.isEligible ? 'required' : ''),
      expression: "isEligible ? 'required' : ''"
    }],
    attrs: {
      "type": "checkbox",
      "id": _vm.evaluation.evaluationSourceId + 'eligA',
      "name": "criteria_group"
    },
    domProps: {
      "value": _vm.evaluation.evaluationSourceId + 'A',
      "checked": Array.isArray(_vm.evaluation.isEligibleA) ? _vm._i(_vm.evaluation.isEligibleA, _vm.evaluation.evaluationSourceId + 'A') > -1 : (_vm.evaluation.isEligibleA)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.evaluation.isEligibleA,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.evaluation.evaluationSourceId + 'A',
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.evaluation.isEligibleA = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.evaluation.isEligibleA = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.evaluation, "isEligibleA", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.evaluation.evaluationSourceId + 'eligA'
    }
  }, [_vm._v("A")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.evaluation.isEligibleB),
      expression: "evaluation.isEligibleB"
    }],
    attrs: {
      "name": "criteria_group",
      "type": "checkbox",
      "id": _vm.evaluation.evaluationSourceId + 'eligB'
    },
    domProps: {
      "value": _vm.evaluation.evaluationSourceId + 'B',
      "checked": Array.isArray(_vm.evaluation.isEligibleB) ? _vm._i(_vm.evaluation.isEligibleB, _vm.evaluation.evaluationSourceId + 'B') > -1 : (_vm.evaluation.isEligibleB)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.evaluation.isEligibleB,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.evaluation.evaluationSourceId + 'B',
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.evaluation.isEligibleB = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.evaluation.isEligibleB = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.evaluation, "isEligibleB", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.evaluation.evaluationSourceId + 'eligB'
    }
  }, [_vm._v("B")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.evaluation.isEligibleC),
      expression: "evaluation.isEligibleC"
    }],
    attrs: {
      "name": "criteria_group",
      "type": "checkbox",
      "id": _vm.evaluation.evaluationSourceId + 'eligC'
    },
    domProps: {
      "value": _vm.evaluation.evaluationSourceId + 'C',
      "checked": Array.isArray(_vm.evaluation.isEligibleC) ? _vm._i(_vm.evaluation.isEligibleC, _vm.evaluation.evaluationSourceId + 'C') > -1 : (_vm.evaluation.isEligibleC)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.evaluation.isEligibleC,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.evaluation.evaluationSourceId + 'C',
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.evaluation.isEligibleC = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.evaluation.isEligibleC = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.evaluation, "isEligibleC", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.evaluation.evaluationSourceId + 'eligC'
    }
  }, [_vm._v("C")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.evaluation.isEligibleD),
      expression: "evaluation.isEligibleD"
    }],
    attrs: {
      "name": "criteria_group",
      "type": "checkbox",
      "id": _vm.evaluation.evaluationSourceId + 'eligD'
    },
    domProps: {
      "value": _vm.evaluation.evaluationSourceId + 'D',
      "checked": Array.isArray(_vm.evaluation.isEligibleD) ? _vm._i(_vm.evaluation.isEligibleD, _vm.evaluation.evaluationSourceId + 'D') > -1 : (_vm.evaluation.isEligibleD)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.evaluation.isEligibleD,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.evaluation.evaluationSourceId + 'D',
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.evaluation.isEligibleD = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.evaluation.isEligibleD = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.evaluation, "isEligibleD", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.evaluation.evaluationSourceId + 'eligD'
    }
  }, [_vm._v("D")])]), _vm._v(" "), _c('div', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('criteria_group')),
      expression: "errors.has('criteria_group')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Criteria is required")])])])]), _vm._v(" "), (_vm.evaluation.isEligibleB) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('associatedPerson')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Associated Person")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.evaluation.associatedPerson),
      expression: "evaluation.associatedPerson"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.evaluation.isEligibleB ? 'required' : ''),
      expression: "evaluation.isEligibleB ? 'required' : '' "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "associatedPerson",
      "type": "text"
    },
    domProps: {
      "value": (_vm.evaluation.associatedPerson)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.evaluation, "associatedPerson", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('associatedPerson')),
      expression: "errors.has('associatedPerson')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Associated Person is required")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.sourceOnly) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('justification')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Discuss Condition and Integrity")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.evaluation.justification),
      expression: "evaluation.justification"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "750px"
    },
    attrs: {
      "name": "justification",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.evaluation.justification)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.evaluation, "justification", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('justification')),
      expression: "errors.has('justification')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Condition and Integrity are required")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "col-md-2 btn btn-primary",
    on: {
      "click": function($event) {
        _vm.saveForm()
      }
    }
  }, [_vm._v("Save Evaluation")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67ba73c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteProduction/SiteEligibilityForm.vue
// module id = 952
// module chunks = 1